import Card from "../../../../../shared/components/Card";

interface CryptoCoinCardProps {
  logo?: string;
  code: string;
  amount: string;
  equivalent: string;
}

export default function CryptoCoinCard({
  logo,
  code,
  amount,
  equivalent,
}: Readonly<CryptoCoinCardProps>) {
  return (
    <Card className="px-3! py-2!">
      <div className="flex flex-col justify-start w-full">
        <div className="flex gap-2">
          {logo ? (
            <img
              src={logo}
              alt="web3-wallet"
              className="rounded-full h-6 w-6"
            />
          ) : (
            <div className="h-6 w-6 rounded-full bg-white/10 text-[10px] flex items-center justify-center uppercase">
              {code.slice(0, 3)}
            </div>
          )}
          <p>{code}</p>
        </div>
        <p className="mt-1 text-xs">{amount}</p>
        <p className="text-[9px] text-label-dark">
          <span>≈</span> {equivalent}
        </p>
        {/* <div className="flex justify-end items-center w-full">
          <SecondaryIcon icon={Icons.ArrowCircle({ height: 15, width: 15 })} />
        </div> */}
      </div>
    </Card>
  );
}
